import { h } from 'preact';
import { Spinner } from '../Spinner';
import type { ComponentShowcase } from '../registry';

export const showcase: ComponentShowcase = {
  name: 'Spinner',
  category: '⏳ Loading',
  description: 'Indicador de carregamento circular com 3 tamanhos (sm, md, lg), texto e modo inline',
  usedIn: ['Chat', 'AgentesPage', 'ChatHubPage'],
  example: () => (
    <div style={{ display: 'flex', gap: 24, alignItems: 'center' }}>
      <Spinner size="sm" />
      <Spinner size="md" />
      <Spinner size="lg" />
      <Spinner size="sm" text="Carregando..." />
      <Spinner size="sm" inline />
    </div>
  ),
};
